module.exports = require("./ff-Adlm-GW.d.ts");